import React, { useEffect, useState } from 'react'
import Navbar from './components/Navbar'
import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate, Outlet } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Profile from './components/Profile';
import Leaderboard from './components/Leaderboard';
import Login from './components/Login';
import Performance from './components/Performance';
import PerformanceDetails from './components/PerformanceDetails';
import Cookies from 'js-cookie';
import { useAuth } from './auth';
import { allRoutes } from './allRoutes';

const ProtectedRoute = ({ children }) => {
  const accessToken = Cookies.get('accessToken');
  // console.log("Access Token in protected route ", accessToken);

  return accessToken ? <>{children}</> : <Navigate to="/login" replace />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((item, index) => (
        <Route
          key={index}
          path={item.path}
          element={
            item.path === '/login' ? (
              item.element
            ) : (
              <ProtectedRoute>{item.element}</ProtectedRoute>
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;